import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, QueryList, } from '@angular/core';
import { Configuracoes } from 'src/app/entities/configuracoes';
import { ConfiguracoesSite } from 'src/app/entities/configuracoesSite';
import { CartService } from 'src/app/services/cart-service';
import { PedidoService } from 'src/app/services/pedido-service';
import { ProductService } from 'src/app/services/product-service';
import { SecurityService } from 'src/app/services/security-service';
import { getOrderItemFromProduct } from '../shared/function';
import { ProductImageComponent } from '../product-image/product-image.component';
import { CatalogItemComponent } from "../../components/catalog-item/catalog-item.component";
import { ToastrService } from "ngx-toastr";
import { ConfiguracoesMisc } from "src/app/entities/configuracoesMisc";
import { ActivatedRoute, Router } from "@angular/router";
declare var $: any;
@Component({
  selector: 'app-catalog-item-line',
  templateUrl: './catalog-item-line.component.html',
  styleUrls: ['./catalog-item-line.component.css']
})
export class CatalogItemLineComponent implements OnInit {
  public site: ConfiguracoesSite;
  MISC: ConfiguracoesMisc;
  productList: QueryList<CatalogItemComponent>;
  @Input()
  public products: any[];

  @Input()
  public produtoColXL;

  @Input()
  public produtoHeight;

  @Input()
  public produtoDescrHeight;

  @Input()
  public produtoDescrFontSize;

  @Input()
  public produtoIndispFontSize;

  @Input()
  public produtoDescrLen;

  @Output()
  public redirectTo = new EventEmitter<number>();

  @ViewChild('productImage', { read: ProductImageComponent, static: true })
  public productImage!: ProductImageComponent;

  public showStock: boolean;
  public userLogged: boolean = false
  public validaEstoque: boolean;
  public quantity: number = 0;
  public pedido: any;
  public API_IMAGENS: String;
  public API_IMAGENS_PRODUTOS: String;
  public SITE: ConfiguracoesSite;
  public mostraPreco = false;
  public stock: string;
  public showProduct = false;
  public selectedProduct = null;
  public config: ConfiguracoesMisc
  constructor(
    public toastService: ToastrService,
    public productService: ProductService,
    public securityService: SecurityService,
    public pedidoService: PedidoService,
    private router: Router,
    public cartService: CartService
  ) {
    this.site = Configuracoes.SITE;
    this.API_IMAGENS = Configuracoes.API_IMAGENS;
    this.API_IMAGENS_PRODUTOS = Configuracoes.API_IMAGENS_PRODUTOS;
    this.SITE = Configuracoes.SITE;
    this.config = Configuracoes.MISC;

    this.pedido = this.pedidoService.pedido;
    if (!this.securityService.hasToken() && !this.SITE.mostraPrecoLoginAtivo)
      this.mostraPreco = true;
    if (this.securityService.hasToken() && (!this.SITE.mostraPrecoPedidoSelecionado || this.pedido)) {
      this.mostraPreco = true;
    }

    if(this.securityService.hasToken() ){
      this.userLogged = true
    }
  }

  ngOnInit() {
    if (this.pedido) {
      this.validaEstoque = this.pedido.tipo.validaEstoque;
    }
    // } else {
      this.showStock = this.SITE.mostraEstoqueDigitacao
    // }
  }

  callPhotos(idProduto, codCor) {
    this.productService.getPhotos(
      idProduto,
      function (resp) {
        let temVariacao = false;
        let _htmlImagens = "";
        for (let i = 0; i < resp.length; i++) {
          let img = resp[i];
          _htmlImagens +=
            '<a href="' +
            Configuracoes.API_IMAGENS_PRODUTOS +
            img.nome +
            '" data-gallery="gallery-catalogo"></a>';
        }
        $("#htmlLightBox").html(_htmlImagens);
        $("#htmlLightBox a:first").ekkoLightbox();
      }.bind(this)
    );


     this.showProduct = false;
    if (Configuracoes.exibeModalProdutoCatalogo) {
      setTimeout(() => {
        this.selectedProduct = idProduto;
        this.showProduct = true;
        $("#productDetails").modal("show");
      });
    } else {
      this.router.navigate(["/produto", idProduto]);
    }
  }

  public addCart(quantity: number, product) {
    this.updateQuantity2(quantity, product);
    if (product.sku) {
      const tax = product.imposto;
      const price = product.precopromocional ? product.precopromocional : product.preco;

      let taxValue = null;
      let taxCalc = {};

      if (tax) {
        taxCalc = this.productService.calculaImposto(price, tax.ipi, tax.alicms, tax.substicms, tax.alicmsorigem, tax.fcpSt);
        taxValue = this.productService.calculaValorImposto(price, tax.ipi, tax.alicms, tax.substicms, tax.alicmsorigem, tax.fcpSt);
      }
      const item = getOrderItemFromProduct(product, taxCalc, tax, taxValue, this.pedidoService.pedido.clientes[0].cliente.id, quantity, quantity * this.getPrice(product));
      this.pedidoService.setCartItemsSku([item], (res) => this.doOnSuccess(res, [item]), res =>this.doOnError(res));
    }
  }

  public doOnSuccess(res, items) {
    // let response = {...res, itens: res.itens.map((r: any)=> ({...r, produtoreferencia: r.produtoReferencia}))}
    this.cartService.addItems(items);
    this.pedidoService.select(res);
  }

  public doOnError(res) {
    // let response = {...res, itens: res.itens.map((r: any)=> ({...r, produtoreferencia: r.produtoReferencia}))}
    if(res.status === 400){
      this.toastService.error(
        JSON.parse(res._body).detail,
        "Produto",
        {
          positionClass: "toast-bottom-left",
        }
      );
    }
  }


  public getPrice(product) {
    let taxValue = 0;
    const tax = product.imposto;

    if (tax) {
      const price = product.precopromocional ? product.precopromocional : product.preco;
      taxValue = this.productService.calculaValorImposto(price, tax.ipi, tax.alicms, tax.substicms, tax.alicmsorigem, tax.fcpSt);
    }

    return product.preco + taxValue;
  }

  updateQuantity(productId: number) {
    let quantity = this.productService.getQuantityByProductId(productId);
    let found: CatalogItemComponent = this.productList.filter(
      (comp) => comp.product.id == productId
    )[0];
    found.updateQuantity(quantity);
  }

  public updateQuantity2(quantity, product) {
    product.quantidade = quantity;
    // this.productImage.updateQuantity(quantity);
    this.ngOnInit();
  }

  redirectTo2(id: number) {
    this.showProduct = false;
    if (Configuracoes.exibeModalProdutoCatalogo) {
      setTimeout(() => {
        this.selectedProduct = id;
        this.showProduct = true;
        $("#productDetails").modal("show");
      });
    } else {
      this.router.navigate(["/produto", id]);
    }
  }
}
